import { useState, useEffect } from 'react';
// @mui
import { Stack, IconButton, InputAdornment, TextField, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom'
import { getAuth } from "firebase/auth";

// components
import Iconify from '../components/iconify';
import { logInWithEmailAndPassword } from "./firebase";

// ----------------------------------------------------------------------

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate()



  const handleClick = async () => {
    setIsLoading(true)
    await logInWithEmailAndPassword(email, password)
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      navigate('/dashboard/applications')
    } else {
      alert('Unable to sign user in')
    }
    setIsLoading(false)
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <>
      {isLoading ?

        <CircularProgress size={24} />
        :
        <>

          <Stack spacing={3}>
            <TextField
              name="email"
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
            />

            <TextField
              name="password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />


            <LoadingButton fullWidth size="large" type="submit" variant="contained" onClick={handleClick}>
              Login
            </LoadingButton>
          </Stack>
        </>
      }
    </>
  );
}
